import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { USAEPayMethodPageRoutingModule } from './usaepay-method-routing.module';

import { USAEPayMethodPage } from './usaepay-method.page';
import { MasterHeaderModule } from '../../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../../master-footer/master-footer.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    USAEPayMethodPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
  ],
  declarations: [USAEPayMethodPage],
})
export class USAEPaymentMethodPageModule {}
